import './Style.scss'
import './App.css';

import Top from './Components/Top';
import Footer from './Components/Footer';

function App() {
  return (
 <>
 <Top/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
<Footer/>
 </>
  );
}

export default App;
